import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';

const TestGoogleAuthPage: React.FC = () => {
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const testAuth = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('test-google-auth');
      
      if (error) {
        setResult({ success: false, error: error.message });
      } else {
        setResult(data);
      }
    } catch (err: any) {
      setResult({ success: false, error: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-2xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>Google Cloud Authentication Test</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button 
              onClick={testAuth} 
              disabled={loading}
              className="w-full"
            >
              {loading ? 'Testing...' : 'Test Google Auth'}
            </Button>
            
            {result && (
              <div className={`p-4 rounded-lg ${
                result.success 
                  ? 'bg-green-50 text-green-800 border border-green-200' 
                  : 'bg-red-50 text-red-800 border border-red-200'
              }`}>
                <h3 className="font-semibold mb-2">
                  {result.success ? '✅ Success' : '❌ Failed'}
                </h3>
                {result.success ? (
                  <p>Project ID: {result.projectId}</p>
                ) : (
                  <p>Error: {result.error}</p>
                )}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestGoogleAuthPage;